<template>
  <div id="app">

    <div style="min-height: 100vh; background-color: rgba(255,255,255,0.7);" :style="get_background_color()">

      <cookie_hint v-if="!$store.getters.cookie" />

      <hit_nav />

      <div class="hit-container-fluid" style="margin-top: 30px;">

       <transition name="moveInUp">
           <router-view class="hit-html-html" />
       </transition>

      </div>

    </div>

    <hit_footer />

  </div>
</template>

<script>

import hit_footer from '@core/components/content/footer.vue'
import hit_nav from '@core/components/content/nav_top.vue'

import cookie_hint from '@core/components/cookie/'

export default {
  name: 'App',

  components: {hit_footer, hit_nav, cookie_hint},

  methods: {

    get_background_color () {

      var r = {

      };

      if (this.$store.getters.page_colors.background_color)
        r = Object.assign(r, {'background-color': this.$store.getters.page_colors.background_color});

      if( this.$store.getters.page_colors.background_image){
        r = Object.assign(r, {'background-image': 'url('+this.$store.getters.page_colors.background_image+')'});
        r = Object.assign(r, {
          'background-size': 'cover',
          'background-position': 'center center',
          'background-attachment': 'fixed'
        });

      }

      return r;
    }
  },

  watch: {
    '$route.name': function () { this.$store.commit('remove_page_color') }
  },

  created: function () {
    this.$store.commit('get_session_user')

    if (this.$route.params.lang) {
      this.$i18n.locale = this.$route.params.lang
      this.$store.commit('set_lang', this.$route.params.lang)
    }
  },
  metaInfo: function () {
    return {
      title: this.$t('company.name')
    }
  }
}
</script>

<style scoped>
#app{
  background: url('/assets/img/person-woman-apple-hotel.jpg') center center fixed;
  background-size: cover;
}
</style>

<style lang="scss">

@import "@core/style/sass/stylesheet/hit_color_style.scss";
@import "@core/style/sass/stylesheet/hit_bootstrap_style.scss";

@media(max-width: 768px){

  .hit-navbar-brand{

    font-size: 3em;
  }

}
.hit-nav.hit-navbar-nav .router-link-exact-active{
  font-weight: bolder;
  border-bottom: 3px solid #55a79a;
}

.slideDown-enter-active,
.slideDown-leave-active {
  transition: opacity;
}

.slideDown-enter,
.slideDown-leave-to {
  opacity: 0;
}

.slideDown-enter-active{
  animation: slideDown 1s ease-in;
}

@keyframes slideDown{
  from {
    -webkit-transform: translate3d(0, -20%, 0);
    transform: translate3d(0, -20%, 0);
    opacity: 0;

  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1;

  }
}

.slideDown-leave-active{
  animation: fadeOut .2s ease-out;
}
@keyframes slideUp{
  from {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 0.5;
  }

  to {
    -webkit-transform: translate3d(0, -20%, 0);
    transform: translate3d(0, -20%, 0);
    opacity: 0;
  }
}

.moveInUp-enter-active{
  animation: fadeIn 2s ease-in;
}

@keyframes fadeOut{
  0%{
    opacity: 1;
  }
  50%{
    opacity: 0.5;
  }
  100%{
    opacity: 0;
  }
}

@keyframes fadeIn{
  0%{
    opacity: 0;
  }
  50%{
    opacity: 0.5;
  }
  100%{
    opacity: 1;
  }
}

.moveInUp-leave-active{
  animation: moveInUp .3s ease-in;
}
@keyframes moveInUp{
 0%{
  transform: translateY(0);
 }
  100%{
  transform: translateY(+400px);
 }
}
</style>
